import { buildResponseJson } from '../../utils/historyView';
import { GROUP_KEY_PREFIX } from '../../constants';
import EntryContext from './EntryContext';
import './StatsSections.css';
import './ResponseTab.css';

function ResponseTab({ entry, existingBlockIds, copiedKey, onCopy, onGoToBlock }) {
    if (!entry) {
        return <div className="ai_chat_panel_stats_empty">No response yet. The JSON generated by the AI appears here after your first request.</div>;
    }

    const json = buildResponseJson(entry);

    return (
        <>
            <EntryContext entry={entry} />
            {entry.error && <div className="ai_chat_panel_history_item_error">{entry.error}</div>}
            <div className="ai_chat_panel_insights_toolbar">
                <button type="button" className="ai_chat_panel_small_button primary" onClick={() => onCopy('json', json)}>
                    {copiedKey === 'json' ? 'Copied ✓' : 'Copy JSON'}
                </button>
                {entry.blocks.length > 0 &&
                    <button type="button" className="ai_chat_panel_small_button" onClick={() => onCopy('ids', entry.blocks.map((block) => block.blockId).join('\n'))}>
                        {copiedKey === 'ids' ? 'Copied ✓' : 'Copy all block IDs'}
                    </button>
                }
            </div>
            <pre className="ai_chat_panel_json">{json}</pre>
            {entry.blocks.length > 0 &&
                <div className="ai_chat_panel_stats_section">
                    <div className="ai_chat_panel_stats_section_title">Blocks ({entry.blocks.length})</div>
                    {entry.blocks.map((block) => {
                        const gone = !existingBlockIds.has(block.blockId);

                        return (
                            <div key={block.stepId} className={'ai_chat_panel_block_row' + (gone ? ' gone' : '')}>
                                <div className="ai_chat_panel_block_row_head">
                                    <span className="ai_chat_panel_block_row_step">{block.stepId.startsWith(GROUP_KEY_PREFIX) ? 'scenario · ' + (((entry.groups || []).find((group) => group.id === block.stepId.slice(GROUP_KEY_PREFIX.length)) || {}).name || block.stepId.slice(GROUP_KEY_PREFIX.length)) : block.stepId + ' · ' + block.type}</span>
                                    {gone && <span className="ai_chat_panel_block_row_gone">removed</span>}
                                    <button type="button" className="ai_chat_panel_small_button" onClick={() => onCopy('block-' + block.stepId, block.blockId)}>
                                        {copiedKey === 'block-' + block.stepId ? 'Copied ✓' : 'Copy'}
                                    </button>
                                </div>
                                {gone
                                    ? <code className="ai_chat_panel_block_row_id">{block.blockId}</code>
                                    : <code className="ai_chat_panel_block_row_id link" title="Go to this block on the canvas" onClick={() => onGoToBlock(block.blockId)}>{block.blockId}</code>
                                }
                            </div>
                        );
                    })}
                </div>
            }
        </>
    );
}

export default ResponseTab;
